import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetTotalBalanceReq, Provider, ProviderTotalBalance } from '@kr/models';

import { GetAccountRes } from '../../pages/account/models';
import { SupportLink } from '../models/support-link.model';

export interface ShellApi {
  getAccount(): Observable<GetAccountRes>;
  getTotalBalances(providers: Provider[]): Observable<ProviderTotalBalance[]>;
  getTotalBalance(params: GetTotalBalanceReq, provider: Provider): Observable<ProviderTotalBalance>;
  getSupportLink(): Observable<SupportLink>;
}

export const SHELL_API = new InjectionToken<ShellApi>('ShellApi');
